/* crÃ©Ã© un fichier Ã  partir de l'url d'une string base64 */
function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

/* DÃ©finit l'image qui sera visible et utilisÃ©e dans le panier */
function setOrderImage(finalImage) {
    const container2 = new DataTransfer();
    const file2 = dataURLtoFile(finalImage, 'final_image.jpg');
    container2.items.add(file2);
    document.getElementById('FinalImageFile').files = container2.files;
}

/* affiche le configurateur et permet les "sauvegardes" */
function launchPersonalization(venum, id, variation, payable_materials,
    price, custom_price, text_price, item,
    final_price, payable_options, payable_text,
    inspirationsList, inspirationImages) {
    $('#reamazejs-container, #zonos, .ly-languages-switcher, #smartbar-app').css('display', 'none');
    window.dispatchEvent(new Event('resize'));
    $(window).scrollTop(0);

    if (inspirationsList) {
        var inspirationsLength = inspirationsList.length;
        var currentConfig = getCurrentConfig(venum, id, variation);
        venum.setConfigurationByJson(currentConfig);
        currentConfig = JSON.parse(currentConfig);
    } else {
        var inspirationsLength = 0;
        venum.setConfigurationByName(variation);
        var currentConfig = JSON.parse(venum.getConfigurationJson());
    }

    /* met en place le prix lors de l'init du configurateur en fonction de la config choisie */
    const options_info = getFinalPrice(
        payable_materials, variantMeshesListToMaterialNames(venum, currentConfig.variantMeshesList), currentConfig.variantTextList, price, custom_price, text_price, final_price
    );
    final_price = options_info[0];
    payable_options = options_info[1];
    payable_text = options_info[2];
    $.when(final_price).done(() => {
        venum.configurationVariantMesh.setPrice(`${final_price.toString()} €`);
    });

    // Uncomment when enabling accessibility
    /*
    customNakerAccessibilitySetup(venum);
    customNakerAccessibilityModal(venum, true);
    */

    /* affichage du configurateur */
    $('.container-3d').css('display', 'block');
    $('body').css('overflow', 'hidden');

    // Uncomment when enabling accessibility
    /*
    venum.container.querySelector(window.focusableSelector).focus();
    trapFocusToElement(venum.container);
    */

    /* lorsque l'utilisateur fait un changement sur sa config */
    venum.configurationVariantMesh.onChange((config) => {
        // vÃ©rifie les configurations de l'utilisateur pour savoir s'il inclut des options payantes
        const options_info = getFinalPrice(
            payable_materials, variantMeshesListToMaterialNames(venum, config.variantMeshesList), config.variantTextList, price, custom_price, text_price, final_price
        );
        final_price = options_info[0];
        payable_options = options_info[1];
        payable_text = options_info[2];
        $.when(final_price).done(() => {
            venum.configurationVariantMesh.setPrice(`€${final_price.toString()}`);
        });
    });
}

/* rÃ©cupÃ¨re la configuration sÃ©lÃ©ctionnÃ©e, prend l'id naker du produit en paramÃ¨tre */
function getCurrentConfig(venum, id, variation) {
    const item = $('.inspiration-item.active').attr('data-item');
    if (item == '-1') {
        venum.setConfigurationByName(variation);
        var config = venum.getConfigurationJson();
    } else {
        var config = JSON.parse(localStorage.getItem(`${id}-inspirations-json`))[item];
        config = validateStoredConfig(config, venum, id, item);
    }
    return config;
}

/* affiche la liste des inspirations */
function displayInspirations(inspirationsLength, id, position) {
    $('.inspiration-item').removeClass('active');
    $('.inspiration-list-user').empty();
    if (position == '-1') {
        $('.inspirations-list .inspiration-item').first().addClass('active');
    }

    for (let i = 0; i < inspirationsLength; i++) {
        const image = new Image(75, 75);
        image.src = JSON.parse(localStorage.getItem(`${id}-inspirations-images`))[i];
        // Uncomment when enabling accessibility
        /* image.setAttribute("alt", `Saved customization ${i + 1}`); */
        if (i == position) {
            var itemDiv = $(`<div class='inspiration-item active' data-item='${i}'></div>`);
        } else {
            var itemDiv = $(`<div class='inspiration-item' data-item='${i}'></div>`);
        }
        itemDiv.html(image);
        $('.inspiration-list-user').append(itemDiv);
    }
}

/* insÃ¨re les images dans le slider */
function setProductPageImages(images) {
    const mainImages = $('.product__media-item');

    mainImages.each(function (index) {
        if (index > 4) {
            $(this).remove();
        } else {
            $(this).find('img').attr('src', images[index]);
            $(this).find('img').attr('srcset', images[index]);
            $(this).find('a').css('display', 'none');
        }
    });

    $('.container-3d').css('opacity', 1);
    $('.container-3d').css('display', 'none');
}

/* rÃ©cupÃ¨re les fichiers de traductions et les ajoute dans le configurateur avec la langue du site */
function setTranslations(venum, product_name) {
    const translations = [];
    const A = $.getJSON("//frvinum.com/cdn/shop/t/44/assets/general_lang.json?v=1702773788494216641725353330", (json) => {
        for (let i = 0; i < json.length; i++) {
            translations.push(json[i]);
        }
    });

    const B = $.getJSON("//frvinum.com/cdn/shop/t/44/assets/materials_lang.json?v=108692896092526756321725353330", (json) => {
        for (let i = 0; i < json.length; i++) {
            translations.push(json[i]);
        }
    });

    const C = $.getJSON("//frvinum.com/cdn/shop/t/44/assets/meshes_lang.json?v=171655574542915228161725353331", (json) => {
        for (let i = 0; i < json.length; i++) {
            if (json[i].key == 'subtitle') {
                json[i].fr = product_name;
                json[i].en = product_name;
                json[i].es = product_name;
                json[i].de = product_name;
                json[i].it = product_name;
                json[i].nl = product_name;
            }
            translations.push(json[i]);
        }
    });

    $.when(A, B, C).done(() => {
        var host = window.location.host;
        var subdomain = host.split('.')[0];
        venum.configurationTranslation.setTranslations(translations);
        if (subdomain == 'uk' || subdomain == 'eu' || subdomain == 'row' || subdomain == 'www') {
            venum.configurationTranslation.setLangage('en');
        } else if (subdomain == 'ch-no' || subdomain == 'ch') {
            venum.configurationTranslation.setLangage('de');
        } else if (subdomain == 'venum-asia-jp' || subdomain == 'jp') {
            venum.configurationTranslation.setLangage('jp');
        } else if (subdomain == 'venum-asia-ru' || subdomain == 'ru') {
            venum.configurationTranslation.setLangage('ru');
        } else {
            venum.configurationTranslation.setLangage(subdomain);
        }
    });
}

/* rÃ©cupÃ¨re le fichiers des matÃ©riaux */
function getPayableMaterials() {
    const materials = [];
    $.getJSON("//frvinum.com/cdn/shop/t/44/assets/materials_lang.json?v=108692896092526756321725353330", (json) => {
        for (let i = 0; i < json.length; i++) {
            if (json[i].paid == 'true') {
                materials.push(json[i].key);
            }
        }
    });

    return materials;
}

/* crÃ©Ã© le nouveau prix en fonction des options payantes */
function getFinalPrice(payable_materials, combosMaterials, combosText, price, custom_price, text_price, final_price) {
    let payable_options = 0;
    let payable_text = 0;
    for (let i = 0; i < combosMaterials.length; i++) {
        if (payable_materials.includes(combosMaterials[i])) {
            payable_options++;
        }
    }
    for (let j = 0; j < combosText.length; j++) {
        if (combosText[j].text != '') {
            payable_text++;
        }
    }
    if (payable_options >= 5) {
        final_price = price + (custom_price * 5) + (text_price * payable_text);
    } else {
        final_price = price + (custom_price * payable_options) + (text_price * payable_text);
    }

    window.custom_3d_payable = {
        material: (payable_options > 5) ? 5 : payable_options,
        text: (payable_text > 2) ? 2 : payable_text
    }
    setCustom3DProductVariantId();

    return [final_price, payable_options, payable_text];
}

/* rÃ©cupÃ¨re le(s) texte(s) de l'utilisateur */
function getTexts(json) {
    var text1; var
        text2;
    if (json.length == 0) {
        text1 = '';
        text2 = '';
    } else if (json.length == 1) {
        var text1 = json[0].text;
        var text2 = '';
    } else {
        var text1 = json[0].text;
        var text2 = json[1].text;
    }

    return [text1, text2];
}

/* rÃ©cupÃ¨re le localsotrage et affiche en console */
function allStorage() {
    const values = [];
    const keys = Object.keys(localStorage);
    let i = keys.length;

    while (i--) {
        values.push(localStorage.getItem(keys[i]));
    }
    console.log(keys);
    console.log(values);
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

function checkCookieVisit() {
    const visit = getCookie('visit');
    if (visit == '') {
        setCookie('visit', true, 100);
        localStorage.clear();
    }
}

function validateStoredConfig(jsonConfig, venum, id, item) {
    let config = JSON.parse(jsonConfig);
    let configNames = JSON.parse(localStorage.getItem(`${id}-inspirations-json-names`))[item];
    for (let i = 0; i < config.variantMeshesList.length; i++) {
        let mesh = config.variantMeshesList[i].meshes[0];
        let material = venum.system.toolMaterial.getMaterialByName(configNames[mesh]).key;
        if (config.variantMeshesList[i].material != material) {
            config.variantMeshesList[i].material = material;
        }
    }
    return JSON.stringify(config);
}

function addToNamedInspirationsList(inspiration, venum, id) {
    const storedConfig = localStorage.getItem(`${id}-inspirations-json-names`);
    let namedInspirationsList = [];
    if (storedConfig != null) {
        namedInspirationsList = JSON.parse(storedConfig);
    }
    let variantMeshesList = JSON.parse(inspiration).variantMeshesList;
    let namedInspiration = {};
    variantMeshesList.forEach(mesh => {
        namedInspiration[mesh.meshes[0]] = venum.system.toolMaterial.getMaterialByKey(mesh.material).name;
    });
    namedInspirationsList.push(namedInspiration);
    localStorage.setItem(`${id}-inspirations-json-names`, JSON.stringify(namedInspirationsList));
}

function variantMeshesListToMaterialNames(venum, variantMeshesList) {
    const MaterialNames = [];
    variantMeshesList.forEach(mesh => {
        const name = venum.system.toolMaterial.getMaterialByKey(mesh.material)?.name;
        if (name) {
            MaterialNames.push(name);
        }
    });
    return MaterialNames;
}

function setCustom3DProductVariantId() {
    const payable = window.custom_3d_payable;
    const size = document.querySelector(".product__info-wrapper variant-radios>:first-child input:checked").value;
    if (
        custom_3d_options_data[size] &&
        custom_3d_options_data[size][payable.material] &&
        custom_3d_options_data[size][payable.material][payable.text]
    ) {
        const current = custom_3d_options_data[size][payable.material][payable.text];
        document.querySelector('.product__info-wrapper input[type="hidden"][name="id"]').value = current.id;
        document.querySelector(`.product__info-wrapper variant-radios>:nth-child(2) input[value="${current.customization}"]`).click();
        document.querySelector(`.product__info-wrapper variant-radios>:nth-child(3) input[value="${current.text}"]`).click();
    }
}

let getVenumObj = () => { };

$(document).ready(() => {
    $(document).on('focus blur', 'input.naker-input', (e) => {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            window.scrollTo(0, 0);
        }
    });

    // allStorage();
    checkCookieVisit();
    let _lsTotal = 0; let _xLen; let
        _x; for (_x in localStorage) { if (!localStorage.hasOwnProperty(_x)) { continue; } _xLen = ((localStorage[_x].length + _x.length) * 2); _lsTotal += _xLen; console.log(`${_x.substr(0, 50)} = ${(_xLen / 1024).toFixed(2)} KB`); } console.log(`Total = ${(_lsTotal / 1024).toFixed(2)} KB`);

    /* mise en place du container */
    const container = document.querySelector('.container-3d');

    /* rÃ©cupÃ¨re l'id du configurateur Ã  lancer pour le produit ainsi que les infos pour les input pouce/poignet */
    const id = $('#personalize3D').attr('data-id');
    const variation = $('#personalize3D').attr('data-variation');
    const product_name = $('h1.product__title').text();
    const thumb_text_input = $('#personalize3D').attr('data-thumb-text');
    const palm_text_input = $('#personalize3D').attr('data-palm-text');
    const product_price = parseInt($('#personalize3D').attr('data-price')) / 100;

    /* localStorage.removeItem(id + '-inspirations-json');
    localStorage.removeItem(id + '-inspirations-images'); */

    const custom_price = 6.00;
    const text_price = 10.00;
    let final_price = 0;
    let payable_options = 0;
    let payable_text = 0;
    /* rÃ©cupÃ¨re les matÃ©riaux pour pouvoir itÃ©rer dessus lors des changements */
    const payable_materials = getPayableMaterials();

    let item = parseInt($('.inspiration-item.active').attr('data-item'));
    let inspirationsList = JSON.parse(localStorage.getItem(`${id}-inspirations-json`));
    let inspirationsImages = JSON.parse(localStorage.getItem(`${id}-inspirations-images`));

    let currentConfig;

    /* lancement du configurateur */
    let venum;

    const showLoader = () => {
        $('.product__info-container').css('opacity', 0.5);
        $('.atc-loader').css('display', 'block');
        $('#personalize3D').attr('disabled', 'disabled');
        $('.product-form__submit').attr('disabled', 'disabled');
    };

    const hideLoader = () => {
        $('.product__info-container').css('opacity', 1);
        $('.atc-loader').css('display', 'none');
        $('#personalize3D').attr('disabled', false);
        setTimeout(() => {
            $('.product-form__submit').attr('disabled', false);
        }, 2000);
    };

    const setTechnicalFile = () => {
        // Do action later to make sure there is nothing else done at the same time
        showLoader();
        setTimeout(() => {
            console.log(2);
            // gÃ©nÃ¨re le fichier technique pour l'ajout au panier */
            venum.configurationTechnicalFile.getProductImagesAndVariants((techImage) => {
                // For test purpose
                // let img = document.createElement('img')
                // img.src = techImage
                // document.body.appendChild(img)
                // console.log(img);
                // console.log(2.5);

                // on met en place le dossier technique dans le formulaire d'ajout du produit
                const container = new DataTransfer();
                const file = dataURLtoFile(techImage, 'customization.jpg');
                container.items.add(file);
                document.getElementById('customizationFile').files = container.files;
                console.log(3);
                const configurationJson = new File([venum.getConfigurationJson()], 'configuration.json', { type: 'application/json' });
                const containerJson = new DataTransfer();
                containerJson.items.add(configurationJson);
                document.getElementById('ConfigurationJson').files = containerJson.files;
            });
            hideLoader();
        }, 100);
    };

    const updateNakerImages = (images) => {
        setProductPageImages(images);
        setOrderImage(images[0]);
        setTechnicalFile();
    };

    showLoader();
    //const venumGlovesViewer = new VenumGlovesViewer({
    const venumGlovesViewer = new NakerStudioViewer({
        container,
        id
    }, (venumViewer) => {
        venum = venumViewer;
        getVenumObj = () => { return venum };

        // Lower image size quality for better performance
        venum.toolScreenshot.setSize({ width: 700, height: 700 });
        venum.system.scene.executeWhenReady(() => {
            // on vÃ©rifie que l'on peut ou non Ã©crire sur le pouce ou le poignet

            if (thumb_text_input == 'true') {
                venumGlovesViewer.addThumbTextInput();
            }
            if (palm_text_input == 'true') {
                venumGlovesViewer.addPalmTextInput();
            }
        });

        // met en place la variation 1 ainsi que le fichier technique
        venum.setConfigurationByName(variation);
        //setTimeout(() => {
        // Without timeout, shotViews doesn't callback
        venum.toolScreenshot.shotViews(null, (images) => {
            updateNakerImages(images);
        });
        //}, 2000);

        currentConfig = JSON.parse(venum.getConfigurationJson());
        // on envoie les traductions dans le viewer
        setTranslations(venum, product_name);

        // modifie le prix de la page produit si besoin
        const options_info = getFinalPrice(
            payable_materials, variantMeshesListToMaterialNames(venum, currentConfig.variantMeshesList),
            currentConfig.variantTextList, product_price, custom_price, text_price, final_price
        );
        final_price = options_info[0];
        payable_options = options_info[1];
        payable_text = options_info[2];
        venum.configurationVariantMesh.setPrice(`${final_price.toString()} €`);
        if (payable_options >= 5) {
            $('.custom-item-5 label').click();
            var label_options = $('.custom-item-5 label').text();
        } else {
            $(`.custom-item-${payable_options} label`).click();
            var label_options = $(`.custom-item-${payable_options} label`).text();
        }
        $(`.text-item-${payable_text} label`).click();
        const label_text = $(`.text-item-${payable_text} label`).text();
        $('.tooltip_options').html(`${label_options} & ${label_text}`);

        const texts = getTexts(currentConfig.variantTextList);

        if (texts[0] != '' && texts[1] != '') {
            $('.tooltip_text').html(`${texts[0]} & ${texts[1]}`);
        } else if (texts[0] != '') {
            $('.tooltip_text').html(texts[0]);
        } else if (texts[1] != '') {
            $('.tooltip_text').html(texts[1]);
        } else {
            $('.tooltip_text').html();
        }

        /* lorsque l'utilisateur clique sur le "confirm" du configurateur */
        venum.onConfirm(({ json, views }) => {
            $('#reamazejs-container, #zonos, .ly-languages-switcher, #smartbar-app').css('display', 'block');
            window.dispatchEvent(new Event('resize'));
            /* rÃ©cupÃ¨re les infos de la nouvelle config */
            // le json
            const newConfig = json;
            // les images des 5 faces
            const images = views;
            updateNakerImages(images);

            if (currentConfig != newConfig) {
                /* ajoute la configuration actuelle Ã  la liste des inspirations */
                if (inspirationsLength == 0) {
                    item = parseInt(item) + 1;
                    inspirationsList = [];
                    inspirationsImages = [];
                    inspirationsList.push(newConfig.toString());
                    inspirationsImages.push(images[0].toString());
                } else if (inspirationsLength == 4) {
                    if (item == '-1') {
                        item = 3;
                        inspirationsList[item] = newConfig.toString();
                        inspirationsImages[item] = images[0].toString();
                    } else {
                        inspirationsList[item] = newConfig.toString();
                        inspirationsImages[item] = images[0].toString();
                    }
                } else {
                    item = inspirationsLength;
                    inspirationsList.push(newConfig.toString());
                    inspirationsImages.push(images[0].toString());
                }

                addToNamedInspirationsList(newConfig, venum, id);
                localStorage.setItem(`${id}-inspirations-json`, JSON.stringify(inspirationsList));
                localStorage.setItem(`${id}-inspirations-images`, JSON.stringify(inspirationsImages));
                inspirationsLength = inspirationsList.length;

                const options_info = getFinalPrice(
                    payable_materials, variantMeshesListToMaterialNames(venum, JSON.parse(newConfig).variantMeshesList),
                    JSON.parse(newConfig).variantTextList, product_price, custom_price, text_price, final_price
                );
                final_price = options_info[0];
                payable_options = options_info[1];
                payable_text = options_info[2];
                $.when(final_price).done(() => {
                    venum.configurationVariantMesh.setPrice(`${final_price.toString()} €`);
                });

                /* sÃ©lÃ©ctionne la bonne variante en fonction du nombre d'option payante */
                if (payable_options >= 5) {
                    $('.custom-item-5 label').click();
                    var label_options = $('.custom-item-5 label').text();
                } else {
                    $(`.custom-item-${payable_options} label`).click();
                    var label_options = $(`.custom-item-${payable_options} label`).text();
                }
                $(`.text-item-${payable_text} label`).click();
                const label_text = $(`.text-item-${payable_text} label`).text();
                $('.tooltip_options').html(`${label_options} & ${label_text}`);

                const texts = getTexts(JSON.parse(newConfig).variantTextList);

                if (texts[0] != '' && texts[1] != '') {
                    $('.tooltip_text').html(`${texts[0]} & ${texts[1]}`);
                } else if (texts[0] != '') {
                    $('.tooltip_text').html(texts[0]);
                } else if (texts[1] != '') {
                    $('.tooltip_text').html(texts[1]);
                } else {
                    $('.tooltip_text').html();
                }

                /* remet en place les inspirations */
                displayInspirations(inspirationsLength, id, item);

                currentConfig = newConfig;
            }

            /* cache le configurateur */
            // Uncomment when enabling accessibility
            /* customNakerAccessibilityModal(venum, false); */
            $('.container-3d').css('display', 'none');
            $('body').css('overflow', 'unset');
            // Uncomment when enabling accessibility
            /* removeTrapFocusToElement(); */
        });

        venum.onExit(() => {
            // l'utilisateur veut quitter l'expÃ©rience
            // Uncomment when enabling accessibility
            /* customNakerAccessibilityModal(venum, false); */
            $('.container-3d').css('display', 'none');
            $('body').css('overflow', 'unset');
            // Uncomment when enabling accessibility
            /* removeTrapFocusToElement(); */
            $('#reamazejs-container, #zonos, .ly-languages-switcher, #smartbar-app').css('display', 'block');
            window.dispatchEvent(new Event('resize'));
        });
    });

    /* permet de sÃ©lÃ©ctionner l'inspiration que l'on souhaite pour repartir de cette config ou ajouter au panier */
    $('.inspirations-list').on('click', '.inspiration-item', function () {
        $('.inspiration-item').removeClass('active');
        showLoader();
        $(this).addClass('active');
        item = $(this).attr('data-item');
        currentConfig = getCurrentConfig(venum, id, variation);
        venum.setConfigurationByJson(currentConfig);
        // $('.container-3d').css('opacity', 0);
        // $('.container-3d').css('display', 'block');

        // change les images de la page produit
        venum.toolScreenshot.shotViews(null, (images) => {
            updateNakerImages(images);
        });

        // modifie le prix de la page produit si besoin
        const options_info = getFinalPrice(
            payable_materials, variantMeshesListToMaterialNames(venum, JSON.parse(currentConfig).variantMeshesList),
            JSON.parse(currentConfig).variantTextList, product_price, custom_price, text_price, final_price
        );
        final_price = options_info[0];
        payable_options = options_info[1];
        payable_text = options_info[2];

        venum.configurationVariantMesh.setPrice(`${final_price.toString()} €`);
        if (payable_options >= 5) {
            $('.custom-item-5 label').click();
            var label_options = $('.custom-item-5 label').text();
        } else {
            $(`.custom-item-${payable_options} label`).click();
            var label_options = $(`.custom-item-${payable_options} label`).text();
        }
        $(`.text-item-${payable_text} label`).click();
        const label_text = $(`.text-item-${payable_text} label`).text();
        $('.tooltip_options').html(`${label_options} & ${label_text}`);

        const texts = getTexts(JSON.parse(currentConfig).variantTextList);
        if (texts[0] != '' && texts[1] != '') {
            $('.tooltip_text').html(`${texts[0]} & ${texts[1]}`);
        } else if (texts[0] != '') {
            $('.tooltip_text').html(texts[0]);
        } else if (texts[1] != '') {
            $('.tooltip_text').html(texts[1]);
        } else {
            $('.tooltip_text').html('');
        }
    });

    /* on rÃ©cupÃ¨re la liste des inspirations pour pouvoir l'afficher et partir des ces configs */
    if (inspirationsList) {
        var inspirationsLength = inspirationsList.length;
        displayInspirations(inspirationsLength, id, '-1');
    } else {
        var inspirationsLength = 0;
    }

    /* lance la configuration au clique sur personalize */
    $('#personalize3D').click(() => {
        // rÃ©cupÃ¨re le prix du produit en format Shopify (*100)
        launchPersonalization(venum, id, variation, payable_materials,
            product_price, custom_price, text_price, item,
            final_price, payable_options, payable_text,
            inspirationsList, inspirationsImages);
    });

    /* active le loader lors de l'ajout au panier */
    /*
    $('.atc-3d').click(() => {
        showLoader();
        setTimeout(() => {
            hideLoader();
        }, 2500);
    });
    */
});